import {makeStyles} from '@material-ui/core';

export const styles = makeStyles(theme => ({
    contentContainer: {
        maxWidth: '100%',
        height: '100%',
        margin: 'auto',
        padding: 0,
        textAlign: 'center',
    },
    table: {
        position: 'relative',
        border: 'solid var(--bd-color)',
        borderWidth: '0 1px 0 0',
        overscrollBehavior: 'contain'
    },
    mobileHeader: {
        position: 'sticky',
        top: 144,
        width: '100%',
        backgroundColor: 'white',
        zIndex: 1,
    },
    shadow: {
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.1)',
    },
    mobileMarketFilter: {
        width: "100%",
        position: 'sticky',
        top: 95,
        backgroundColor: 'white',
        zIndex: 1,
    },
    row: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    headerCol: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        height: '100%',
        width: '100%',
        "& p": {
            margin: 0
        }
    },
    mobileSportsBook: {
        marginLeft: '10%',
        '& img': {
            display: 'block',
            maxWidth: '104px',
            height: '40px',
            width: 'auto',
            objectFit: 'contain',
        },
    },
    justifyStart: {
        justifyContent: 'flex-start !important',
    },
    fullGameCol: {
        fontSize: 18,
        "& p": {
            marginTop: 6,
            fontFamily: 'proxima-nova',
        }
    },
    odds: {
        padding: '0 12px 0 3px',
    }
}));